export default "__VITE_ASSET__BrfzBLga__"